import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function NoneCoffeeAIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <circle cx="12" cy="12" r="12" fill={color}/>
            <path d="M15.75 7.85004L17.25 11.35V17.35C17.25 17.9023 16.8023 18.35 16.25 18.35H13.75" stroke="white"/>
            <path d="M8.75 7.85002V5.65002H15.75V7.85002" stroke="white" strokeLinejoin="round"/>
            <path d="M13.75 11.35H17.25" stroke="white" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M6.75 17.35V11.35L8.75 7.84998H15.25L13.75 11.35V18.35H7.75C7.19772 18.35 6.75 17.9023 6.75 17.35ZM10.25 15.1C11.4006 15.1 12.3333 14.5403 12.3333 13.85C12.3333 13.1596 11.4006 12.6 10.25 12.6C9.09941 12.6 8.16667 13.1596 8.16667 13.85C8.16667 14.5403 9.09941 15.1 10.25 15.1Z"
                fill="white"/>
            <path d="M6.75 11.35V17.35C6.75 17.9023 7.19772 18.35 7.75 18.35H13.75V11.35L15.25 7.84998H8.75L6.75 11.35Z"
                stroke="white"/>
        </svg>

    );
}

export default NoneCoffeeAIcon;
